export default __webpack_public_path__ + "static/media/desktop.8a44016a.png";